@if (template) {
  <article>
    <section>
      <app-toolbar>
        <div class="left">
          <input class="fourd" [(ngModel)]="template.title" placeholder="Title" />
        </div>
        <div class="right">
          <app-button-sensors [maxSensorsToShow]="4" [selectedItems]="template.assetTypeIds" (onSelect)="sensorsSelected($event)"></app-button-sensors>
          @if (cats.length) {
            <app-select [list]="cats" [value]="template.category.id"></app-select>
          }
        </div>
      </app-toolbar>
      <app-theme-page-section theme="white" [border]="false" label="Setpoints" [toolbar]="[{ icon: 'mdi-eraser', label: 'clear form', tag: 'CLEAR', text: 'clear', tooltipposition: 'left' }]" (onToolbarClick)="toolbarClick($event)">
        <table class="hidden-xs table table-sm setpoint-table">
          <thead>
            <th>Day</th>
            <th tooltipPosition="left" [title]="rangeId === 3 ? 'Trigger before this time' : 'Trigger from this time'">
              @if (rangeId === 3) {
                <span
                  >Trigger
                  <p>Before</p></span
                >
              }
              @if (rangeId === 2) {
                <span>From</span>
              }
            </th>
            <th tooltipPosition="left" [title]="rangeId === 3 ? 'Trigger after this time' : 'Trigger before this time'">
              @if (rangeId === 3) {
                <span
                  >Trigger
                  <p>After</p></span
                >
              }
              @if (rangeId === 2) {
                <span>To</span>
              }
            </th>
            <th class="rag-red" [ngClass]="{ enabled: template.alarms.red_min }">
              Red Min
              <p title="Enable alarm - Red minimum breached" tooltipPosition="top">
                <label class="switch" title=""><input name="typetoggle" type="checkbox" [(ngModel)]="template.alarms.red_min" (click)="linkRule()" /><span class="checkboxslider alarm round"></span> </label>
              </p>
            </th>
            <th class="rag-amber" [ngClass]="{ enabled: template.alarms.amber_min }">
              Amber Min
              <p title="Enable alarm - Amber minimum breached" tooltipPosition="top">
                <label class="switch" title=""><input name="typetoggle" type="checkbox" [(ngModel)]="template.alarms.amber_min" (click)="linkRule()" /><span class="checkboxslider alarm round"></span> </label>
              </p>
            </th>
            <th class="green-gap">
              Green
              <p></p>
            </th>
            <th class="rag-amber" [ngClass]="{ enabled: template.alarms.amber_max }">
              Amber Max
              <p title="Enable alarm - Amber maximum breached" tooltipPosition="top">
                <label class="switch" title=""><input name="typetoggle" type="checkbox" [(ngModel)]="template.alarms.amber_max" (click)="linkRule()" /><span class="checkboxslider alarm round"></span> </label>
              </p>
            </th>
            <th class="rag-red" [ngClass]="{ enabled: template.alarms.red_max }">
              Red Max
              <p title="Enable alarm - Red maximum breached" tooltipPosition="top">
                <label class="switch" title=""><input name="typetoggle" type="checkbox" [(ngModel)]="template.alarms.red_max" (click)="linkRule()" /><span class="checkboxslider alarm round"></span> </label>
              </p>
            </th>
            @if (rangeId === 2) {
              <th class="all-day">All Day</th>
            }
            <th>Enabled</th>
            <th></th>
          </thead>
          <tbody>
            @for (setpoint of template.setpoints; track setpoint; let i = $index) {
              <tr [class.chart-clicked-weekday]="selectedWeekday === i">
                <td>
                  {{ weekdays[i].title }}
                </td>
                @if (!setpoint.allday) {
                  <td>
                    <input type="time" [(ngModel)]="setpoint.startsAt" (blur)="onBlur()" [disabled]="!setpoint.isActive" (keyup)="generateGreenRAGTooltip()" />
                  </td>
                }
                @if (setpoint.allday) {
                  <td>00:00:00</td>
                }
                @if (!setpoint.allday) {
                  <td>
                    <input type="time" [(ngModel)]="setpoint.endsAt" (blur)="onBlur()" [disabled]="!setpoint.isActive" (keyup)="generateGreenRAGTooltip()" />
                  </td>
                }
                @if (setpoint.allday) {
                  <td>23:59:59</td>
                }
                <td class="rag-red">
                  <input [(ngModel)]="setpoint.red_min" style="width: 60px" [disabled]="!setpoint.isActive" (blur)="change('red_min')" (keyup)="generateGreenRAGTooltip()" />
                </td>
                <td class="rag-amber">
                  <input [(ngModel)]="setpoint.amber_min" style="width: 60px" [disabled]="!setpoint.isActive" (blur)="change('amber_min')" (keyup)="generateGreenRAGTooltip()" />
                </td>
                <td class="green-gap"></td>
                <td class="rag-amber">
                  <input [(ngModel)]="setpoint.amber_max" style="width: 60px" [disabled]="!setpoint.isActive" (blur)="change('amber_max')" (keyup)="generateGreenRAGTooltip()" />
                </td>
                <td class="rag-red">
                  <input [(ngModel)]="setpoint.red_max" style="width: 60px" [disabled]="!setpoint.isActive" (blur)="change('red_max')" (keyup)="generateGreenRAGTooltip()" />
                </td>
                @if (rangeId === 2) {
                  <td class="all-day">
                    <label class="switch" title="Enable to run all day"><input name="typetoggle" type="checkbox" [(ngModel)]="setpoint.allday" (click)="allday(i)" /><span class="checkboxslider round"></span></label>
                  </td>
                }
                <td>
                  <label class="switch" title="Enable this line"><input name="typetoggle" type="checkbox" [(ngModel)]="setpoint.isActive" (click)="enableWeekday(i)" /><span class="checkboxslider round"></span></label>
                </td>
                <td class="actions">
                  <i class="fa fa-copy" [class.disabled]="!setpoint.isActive" title="Copy" (click)="copy(i)"></i>
                  <i class="fa fa-paste" [class.disabled]="!copySetpoint" title="Paste" (click)="paste(i)"></i>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </app-theme-page-section>
      <section>
        <span class="p-float-label">
          <textarea pInputTextarea [(ngModel)]="template.notes"></textarea>
          <label>Notes</label>
        </span>
      </section>
    </section>
    <footer>
      <section>
        <div>
          <app-button [disabled]="!template.id" routerLink="scheduler" title="Create a new schedule from this template" icon="mdi mdi-calendar-arrow-left" label="Scheduler"></app-button>
        </div>
        <app-button (click)="delete()" icon="mdi mdi-trash-can-outline" label="Delete" [disabled]="!template.id"></app-button>
        <app-button (click)="cancel()" icon="mdi mdi-close" label="Cancel"></app-button>
        <!--	<app-button [disabled]="!template.id" title="Create a new template based on these values" tooltipPosition="top"
            (click)="apiService.toastWarn('not implemented','')" class="p-button-outlined"
          icon="mdi mdi-content-copy" label="Duplicate"></app-button> -->
        <app-button (click)="submit()" icon="mdi mdi-check" label="Save Changes"></app-button>
      </section>
      <section>
        <app-info-panel type="note">
          @if (template.id) {
            <ul>
              <li>Saving the template will effect all existing and new schedules based on this template.</li>
              <li>When making changes, you can duplicate this template if you'd like to keep existing schedules on previous values.</li>
            </ul>
          }
          @if (!template.id) {
            <ul>
              <li style="vertical-align: middle">
                After saving this new template you can come back here and create schedules through the
                <span class="button">
                  <span class="p-button-icon p-button-icon-left mdi mdi-calendar-arrow-left" aria-hidden="true"></span>
                  Scheduler
                </span>
                button.
              </li>
            </ul>
          }
        </app-info-panel>
      </section>
    </footer>
  </article>
}
